// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organization .el-alert[data-v-7cf4a83d]{margin-bottom:20px}.domain[data-v-7cf4a83d]{border-bottom:1px solid #edf0f4;padding:10px 0 20px}.assign[data-v-7cf4a83d]{display:flex;gap:12px;margin-top:20px}.el-checkbox[data-v-7cf4a83d]{margin:0 12px}", ""]);
// Exports
module.exports = exports;
